import React, { useState } from "react";

// Strip HTML tags and limit length — defence-in-depth before Supabase upsert
const sanitize = (str, maxLen = 200) =>
  String(str).replace(/<[^>]*>/g, "").replace(/[<>]/g, "").trim().slice(0, maxLen);

const FIELDS = [
  ["Project Name", "name"],
  ["Client",       "client"],
  ["Address / Site","address"],
];

export default function ProjectEditor({ project, onSave, onClose }) {
  const [vals, setVals] = useState({
    name:    project.name    || "",
    client:  project.client  || "",
    address: project.address || "",
  });

  const set = key => e => setVals(v => ({ ...v, [key]: e.target.value }));

  return (
    <div style={{ position: "fixed", inset: 0, background: "#000a", zIndex: 100, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ background: "#09090f", border: "1px solid #1e3d66", borderRadius: 10, padding: "24px", width: 340, boxShadow: "0 24px 64px #000e" }}>
        <div style={{ fontSize: 9, color: "#3b82f6", letterSpacing: 2, marginBottom: 16, fontWeight: 800 }}>
          PROJECT DETAILS
        </div>

        {FIELDS.map(([label, key]) => (
          <div key={key} style={{ marginBottom: 12 }}>
            <div style={{ fontSize: 8, color: "#4a5e70", marginBottom: 4 }}>{label}</div>
            <input
              value={vals[key]}
              onChange={set(key)}
              style={{
                width: "100%", padding: "7px 10px", background: "#0c1320",
                border: "1px solid #1e3040", color: "#c4cdd8", borderRadius: 5,
                fontSize: 11, fontFamily: "'JetBrains Mono',monospace", outline: "none",
              }}
            />
          </div>
        ))}

        <div style={{ display: "flex", gap: 8, marginTop: 16 }}>
          <button
            onClick={() => onSave({ name: sanitize(vals.name, 120), client: sanitize(vals.client, 120), address: sanitize(vals.address, 240) })}
            style={{ flex: 1, padding: "9px", background: "#0c2318", border: "1px solid #4ade8040", color: "#4ade80", borderRadius: 5, cursor: "pointer", fontSize: 10, fontFamily: "inherit", fontWeight: 700 }}
          >
            ✓ Save
          </button>
          <button
            onClick={onClose}
            style={{ padding: "9px 14px", background: "transparent", border: "1px solid #131924", color: "#4a5e70", borderRadius: 5, cursor: "pointer", fontSize: 10 }}
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  );
}
